// extracted by mini-css-extract-plugin
export var dataCell = "_pg-2";
export var dataRow = "_pg-0";
export var headerRow = "_pg-1";